"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    general: {
        labels: {
            total: 'Total',
            reserve: 'Reserve',
            treasury: 'Treasury',
            holder: 'Holder',
        },
        yes: 'Yes',
        no: 'No',
        true: 'True',
        false: 'False',
        properties: {
            name: 'Name',
            notes: 'Notes',
            symbol: 'Symbol',
            version: 'Version',
            currency: 'Currency',
            decimals: 'Decimals',
            protocol: 'Protocol',
            standard: 'Standard',
            amount: 'Amount',
            addresses: 'Addresses',
            tokenType: 'Token type',
            privacyEnabled: 'Privacy is enabled',
            kycEnabled: 'Whitelist is enabled',
            isKYCable: 'Whitelist is enabled',
            blacklistEnabled: 'Blacklist is enabled',
            isBlacklistable: 'Blacklist is enabled',
            numberToCreate: 'Number to create',
            traderAddressId: 'Trader address',
            tempDocuments: 'Documents',
            token: 'Token',
            tokenId: 'Token',
            poolToken: 'Pool token',
            poolTokenId: 'Pool token',
            trader: 'Trader address',
            payoutPerIndex: 'Payout per index',
            startAt: 'Start At',
            endAt: 'End At',
            payoutToken: 'Payout token',
            eligibilityTokenId: 'Eligibility token',
            tokenAddress: 'Token address',
            recipientAddress: 'Recipient address',
        },
        protocols: {
            ALGORAND: 'Algorand',
            ARBITRUM: 'Arbitrum',
            APTOS: 'Aptos',
            ETHEREUM: 'Ethereum',
            ETHERLINK: 'Etherlink',
            HEDERA: 'Hedera',
            POLYGON: 'Polygon',
            SOLANA: 'Solana',
            XDC: 'XDC',
            XRP_LEDGER: 'XRP Ledger',
        },
        standards: {
            ASA: 'Standard Assets',
            ERC20: 'ERC20',
            ERC721: 'ERC721',
            ERC20_POOL_TOKEN: 'ERC20 Pool Token',
            FUNGIBLE_COMMON: 'Fungible',
            NON_FUNGIBLE_UNIQUE: 'Non Fungible',
            FUNGIBLE_COMMON_POOL: 'Fungible Pool Token',
            TOKEN_2022: 'Token 2022',
        },
        tokenTypes: {
            REGULAR: 'Regular',
            POOL: 'Pool',
            ERC20: 'ERC20',
            ERC721: 'ERC721',
        },
    },
    holder_one: 'Holder',
    holder_other: 'Holders',
    holder: {
        createNew: 'Create new holder',
        managementScreen: 'Holders Management',
        address: 'Holder address',
        toast: {
            reactivate: 'Holder reactivated',
            archive: 'Holder archived',
            removeAddressFromWhitelist: 'Remove holder address request sent for approval',
            created: 'Holder created',
        },
        dialog: {
            reactivate: 'Are you sure you want to reactivate the holder?',
            archive: 'Are you sure you want to archive the holder?',
            removeAddressFromWhitelist: 'Remove holder address from token whitelist',
            creation: 'Holder creation',
        },
        forms: {
            selectHolder: 'Select Holder',
            selectManageHolder: 'Select the holder you would like to manage',
        },
        errors: {
            missingAddressHolderToWhitelist: 'There are no addresses for this holder that can be whitelisted.',
            uniqueHolderName: 'This holder name is already used',
        },
    },
    standards: {
        listStandards: {
            title: 'EVM standards',
        },
        buttons: {
            deployImplementation: 'Deploy Implementation',
            deployImplementationHelper: 'This implementation contract will be used on all the tokens that are created with this standard',
        },
        dialogs: {
            deployImplementation: 'Deploy implementation contract?',
        },
    },
    exports: {
        getAll: {
            title: 'Exports',
        },
        buttons: {
            download: 'Download',
        },
        type: {
            EXPORT_TOKENS: 'Export tokens',
        },
        status: {
            PENDING: 'Pending',
            READY: 'Ready',
            FAILED: 'Failed',
        },
    },
    headers: {
        common: {
            type: 'Type',
            value: 'Value',
            protocol: 'Protocol',
            tokenName: 'Token name',
            underlyingTokenName: 'Underlying token',
            standard: 'Standard',
            symbol: 'Symbol',
            balance: 'Balance',
            holderAddress: 'Holder address',
            holderAddressName: 'Holder address name',
            holderName: 'Holder name',
            name: 'Name',
            version: 'Version',
            status: 'Status',
            privacy: 'Privacy enabled',
            fileName: 'File name',
            createdBy: 'Created by',
            createdAt: 'Created at',
        },
    },
    requiredChecks: {
        genericErrorMessage: 'An error ocurred while trying to perform the check',
        distributionFundsCheck: {
            name: 'Funds verification',
            description: 'Ensure sufficient funds are available for distribution.',
            actionRequired: 'Please ensure that the account balance meets the required minimum of {{distributionTotal}} to proceed with the operation.',
        },
        distributionGasCheck: {
            name: 'Gas verification',
            description: 'Ensure sufficient gas is available for the for the entire distribution process.',
            actionRequired: 'Please ensure that the account balance meets the required minimum of {{gasTotalCost}} to proceed with the operation.',
        },
        distributionAssociatedTokenCheck: {
            name: 'Associated token',
            description: 'Ensure the elegible accounts for the distribution has associated the token.',
            actionRequired: 'Please ensure that the accounts {{accounts}} are associated with the distribution token {{tokenSymbol}}.',
        },
        distributionTrustLineTokenCheck: {
            name: 'Trust line',
            description: 'Ensure the elegible accounts for the distribution have a trust line with the token.',
            actionRequired: 'Please ensure that the wallets {{wallets}} have a trust line with the token {{tokenSymbol}}.',
        },
        changeOwnerAssociatedTokenCheck: {
            name: 'Associated token',
            description: 'Ensure the new owner has associated the token.',
            actionRequired: 'Please ensure that the new owner has associated the token to proceed with the operation.',
        },
        grantKycAssociatedTokenCheck: {
            name: 'Associated token',
            description: 'Ensure the account to be KYCed has associated the token.',
            actionRequired: 'Please ensure that account to be KYCed has associated the token to proceed with the operation.',
        },
        grantKycAssociatedTokenPoolTokenCheck: {
            name: 'Associated token',
            description: 'Ensure the token is registered in the pool token contract.',
            actionRequired: 'Register the token in the pool token contract to proceed with the operation. The pool token will then be automatically associated with the token.',
        },
        changeOwnerTransactionSignatureCheck: {
            name: 'Transaction signature',
            description: 'Ensure the new owner has signed the transaction.',
            actionRequired: 'Please ensure that the new owner has signed the transaction to proceed with the operation. Download the serialized transaction and have the new owner sign it. Attach the signed transaction to the request.',
        },
        trustLineCheck: {
            name: 'Trust line',
            description: 'Ensure the holder has a trust line with the token.',
            actionRequired: 'Please ensure that the holder has a trust line with the token to proceed with the operation.',
        },
        fundsTrustLineCheck: {
            name: 'Funds for trust line',
            description: 'Ensure the {{type}} has at least 2 XRP to create a trust line.',
            actionRequired: 'Please add {{additionalFunds}} XRP so that the {{type}} has at least 2 XRP to create a line of trust with the token to proceed with the operation.',
        },
    },
    errors: {
        token: {
            unexpectedBalanceError: 'An unexpected error occurred while trying to retrieve the token balance. Please try again later.',
        },
    },
    adminApproval: {
        operationDetailsModal: {
            title: 'Operation details',
            noData: 'No operation data available',
            keyLabel: 'Key',
            valueLabel: 'Value',
        },
    },
    token: {
        history: {
            status: {
                approved: 'Approved',
                notApproved: 'Not approved',
                error: 'Error',
            },
        },
        documents: {
            title: 'Documents',
            actions: {
                addNew: 'Add new document',
                preview: 'Preview',
                download: 'Download',
            },
        },
    },
    payoutContracts: {
        listAll: {
            title: 'Payout contracts',
            subtitle: 'List of payout contracts',
        },
        showDetails: {
            title: 'Payout contracts',
            loadingMessage: 'Loading payout token data...',
            tabs: {
                history: 'History',
                whitelist: 'Whitelist',
            },
            actions: {
                pause: {
                    label: 'Pause',
                    message: 'Are you sure that you want to pause the payout contract?',
                    text: 'You can unpause it later.',
                    successMessage: 'Pause payout contract request sent for approval',
                },
                unpause: {
                    label: 'Unpause',
                    message: 'Are you sure that you want to unpause the payout contract?',
                    text: 'You can pause it later.',
                    successMessage: 'Unpause payout contract request sent for approval',
                },
                setPayoutPerIndex: {
                    label: 'Update payout per index',
                    message: 'Update payout per index',
                    input: 'Payout per index',
                    button: 'Update',
                    successMessage: 'Update payout per index request sent for approval',
                },
                setEligibilityToken: {
                    label: 'Update eligibility token',
                    message: 'Update eligibility token',
                    input: 'Eligibility token',
                    button: 'Update',
                    successMessage: 'Update eligibility token request sent for approval',
                },
                setPayoutToken: {
                    label: 'Update payout token',
                    message: 'Update payout token',
                    input: 'Payout token',
                    button: 'Update',
                    successMessage: 'Update payout token request sent for approval',
                },
            },
        },
        whitelist: {
            headers: {
                status: 'Status',
                holderName: 'Holder name',
                holderAddress: 'Holder address',
                holderAddressName: 'Holder address name',
            },
            statuses: {
                whitelisted: 'Whitelisted',
                removed: 'Removed',
            },
            actions: {
                grantKyc: {
                    label: 'Grant KYC',
                    message: 'Are you sure that you want to grant account access to the payout contract?',
                    text: 'You can revoke the KYC back later',
                    selectHolder: 'Select Holder',
                    selectAddress: 'Select the address',
                    successMessage: 'Grant KYC request sent for approval',
                },
                revokeKyc: {
                    label: 'Revoke KYC',
                    message: 'Are you sure that you want to revoke account access to the payout contract?',
                    text: 'You can grant the KYC back later',
                    successMessage: 'Revoke KYC request sent for approval',
                },
            },
        },
        history: {
            headers: {
                holderName: 'Holder name',
                holderAddress: 'Holder address',
                holderAddressName: 'Holder address name',
            },
        },
        labels: {
            name: 'Name',
            contractAddress: 'Payout contract address',
            payoutToken: 'Payout token',
            eligibilityToken: 'Eligibility token',
            status: 'Status',
            startDate: 'Start date (UTC)',
            endDate: 'End date (UTC)',
            protocol: 'Protocol',
            payoutIndex: 'Payout Index',
            showFailed: 'Show failed actions',
            dateTime: 'Date time',
            actionType: 'Action type',
            amount: 'Amount',
        },
        actions: {
            pause: 'Pause',
            unpause: 'Unpause',
            createNewContract: 'Create new payout contract',
            updatePayoutIndex: 'Update payout index',
            updateEligibilityToken: 'Update eligibility token',
            updatePayoutToken: 'Update payout token',
        },
        createNewContract: {
            labels: {
                protocol: 'Protocol',
                name: 'Name',
                startAt: 'Start date (UTC)',
                endAt: 'End date (UTC)',
                eligibilityToken: 'Eligibility token',
                payoutToken: 'Payout token',
            },
            successMessage: 'Payout contract request sent for approval',
        },
        statuses: {
            SCHEDULED: 'Scheduled',
            ACTIVE: 'Active',
            PAUSED: 'Paused',
            FINISHED: 'Finished',
        },
    },
};
